export const modern = [
  {
    number: 'MB100',
    hasModel: false,
  },
  {
    number: 'MB101',
    hasModel: false,
  },
  {
    number: 'MB102',
    hasModel: false,
  },
  {
    number: 'MB104',
    hasModel: false,
  },
  {
    number: 'MB105',
    hasModel: true,
  },
  {
    number: 'MB106',
    hasModel: false,
  },
  {
    number: 'MB107',
    hasModel: false,
  },
  {
    number: 'MB108',
    hasModel: false,
  },
  {
    number: 'MB109',
    hasModel: false,
  },
  {
    number: 'MB110',
    hasModel: true,
  },
  {
    number: 'MB111',
    hasModel: false,
  },
  {
    number: 'MB112',
    hasModel: false,
  },
  {
    number: 'MB113',
    hasModel: false,
  },
  {
    number: 'MB114',
    hasModel: true,
  },
  {
    number: 'MB115',
    hasModel: false,
  },
  {
    number: 'MB116',
    hasModel: true,
  },
  {
    number: 'MB117',
    hasModel: false,
  },
  {
    number: 'MB118',
    hasModel: false,
  },
  {
    number: 'MB119',
    hasModel: false,
  },
  {
    number: 'MB120',
    hasModel: true,
  },
  {
    number: 'MB122',
    hasModel: false,
  },
  {
    number: 'MB124',
    hasModel: true,
  },
  {
    number: 'MB125',
    hasModel: true,
  },
  {
    number: 'MB127',
    hasModel: false,
  },
  {
    number: 'MB129',
    hasModel: false,
  },
  {
    number: 'MB130',
    hasModel: true,
  },
  {
    number: 'MB131',
    hasModel: false,
  },
  {
    number: 'MB133',
    hasModel: true,
  },
  {
    number: 'MB134',
    hasModel: false,
  },
  {
    number: 'MB135',
    hasModel: false,
  },
  {
    number: 'MB136',
    hasModel: true,
  },
  {
    number: 'MB137',
    hasModel: false,
  },
  {
    number: 'MB138',
    hasModel: false,
  },
  {
    number: 'MB139',
    hasModel: false,
  },
  {
    number: 'MB140',
    hasModel: false,
  },
  {
    number: 'MB141',
    hasModel: false,
  },
  {
    number: 'MB142',
    hasModel: false,
  },
  {
    number: 'MB143',
    hasModel: true,
  },
  {
    number: 'MB144',
    hasModel: false,
  },
  {
    number: 'MB145',
    hasModel: false,
  },
  {
    number: 'MB146',
    hasModel: false,
  },
  {
    number: 'MB147',
    hasModel: false,
  },
  {
    number: 'MB148',
    hasModel: true,
  },
  {
    number: 'MB149',
    hasModel: true,
  },
  {
    number: 'MB150',
    hasModel: true,
  },
  {
    number: 'MBX',
    hasModel: false,
  },
];
